import React from 'react';
import PropTypes from 'prop-types';
import {createForm, formShape} from 'rc-form';
import {addFlashMessage} from 'actions/flash-message';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import QuizRandomizedQuestionForm from './QuizRandomizedQuestionForm';
import {isEmpty} from 'lodash/lang';


class QuizRandomizedQuestion extends React.Component {
    static propTypes = {
        form: formShape,
    };

    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            submitting: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        const {form: {validateFields}} = this.props;
        validateFields((error, value) => {
            if (!isEmpty(error)) {
                return;
            }
            this.props.onSubmit(value);
        });
    }

    render() {
        const {submitting} = this.state;
        const {initialValues, form} = this.props;

        return (
            <>
                <QuizRandomizedQuestionForm {...{
                    form,
                    submitting,
                    onSubmit: this.handleSubmit,
                    initialValues
                }} />
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

QuizRandomizedQuestion.contextTypes = {
    router: PropTypes.object.isRequired
};

export default withRouter(connect(
    null,
    mapDispatchToProps
)(createForm()(QuizRandomizedQuestion)));
